/* District Bangle — faq-page.js
   Client-side search + category filtering over rows that are already in the
   HTML (so every answer is indexable and the page works with JS off). */
import { BaseElement, define } from '@theme/global';

class FaqPage extends BaseElement {
  init() {
    this.items = [...this.querySelectorAll('[data-faq-item]')];
    this.none = this.querySelector('[data-faq-none]');
    this.cats = [...this.querySelectorAll('[data-faq-cat]')];
    this.search = this.querySelector('[data-faq-search]');
    this.cat = 'all';
    this.q = '';

    this.cats.forEach((btn) => this.listen(btn, 'click', () => {
      this.cat = btn.dataset.faqCat;
      this.cats.forEach((b) => b.classList.toggle('is-on', b === btn));
      this.apply();
    }));
    if (this.search) this.listen(this.search, 'input', () => { this.q = this.search.value.trim().toLowerCase(); this.apply(); });
  }

  apply() {
    let shown = 0;
    this.items.forEach((item) => {
      const inCat = this.cat === 'all' || item.dataset.cat === this.cat;
      const text = ((item.querySelector('[data-faq-q]')?.textContent || '') + ' ' +
                    (item.querySelector('[data-faq-a]')?.textContent || '')).toLowerCase();
      const match = !this.q || text.includes(this.q);
      const show = inCat && match;
      item.hidden = !show;
      if (show) shown += 1; else item.open = false;
    });
    if (this.none) this.none.hidden = shown > 0;
  }
}

define('faq-page', FaqPage);
